export default __webpack_public_path__ + "static/media/3672.c1b46792.png";